import { matchTrackerApi } from '../../modules/servers/api'
import { createCrudEndpoints } from '../api'
import { RawTeamPersonData } from '../types'
import { RawPersonData } from './types'

const tagType = 'people' as const

// The person id is server-assigned and img is optional, so both are omitted from
// the create payload rather than sent as empty strings.
export type CreatePersonRequest = Partial<Omit<RawTeamPersonData, 'person'>> & {
  person: Omit<RawPersonData, 'id' | 'img'> & { id?: string; img?: string }
}

export const peopleApi = matchTrackerApi.injectEndpoints({
  endpoints: (builder) => ({
    // Generic CRUD endpoints //
    ...createCrudEndpoints<RawPersonData>(tagType, builder),

    // Create a person and link them to a team through the teampeople endpoint
    createPerson: builder.mutation<RawTeamPersonData, CreatePersonRequest>({
      query: (body) => ({
        url: `/teampeople`,
        method: 'POST',
        body
      }),
      invalidatesTags: () => {
        return [
          { type: tagType, id: 'LIST' },
          { type: 'teampeople', id: 'LIST' }
        ]
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        // Optimistic update can be handled here if needed
      }
    })
  })
})

export const {
  usePeople_getAllQuery,
  usePeople_getByIdQuery,
  usePeople_createMutation,
  usePeople_updateMutation: useUpdatePersonMutation,
  useCreatePersonMutation
} = peopleApi
